var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectedUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.8516C11.866 15.8516 15 12.7176 15 8.85156C15 4.98557 11.866 1.85156 8 1.85156C4.13401 1.85156 1 4.98557 1 8.85156C1 12.7176 4.13401 15.8516 8 15.8516ZM8 16.8516C12.4183 16.8516 16 13.2698 16 8.85156C16 4.43328 12.4183 0.851562 8 0.851562C3.58172 0.851562 0 4.43328 0 8.85156C0 13.2698 3.58172 16.8516 8 16.8516Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99902 7.70312C8.60902 7.70312 9.10352 7.20863 9.10352 6.59863C9.10352 5.98864 8.60902 5.49414 7.99902 5.49414C7.38903 5.49414 6.89453 5.98864 6.89453 6.59863C6.89453 7.20863 7.38903 7.70312 7.99902 7.70312ZM7.99902 8.70312C9.1613 8.70312 10.1035 7.76091 10.1035 6.59863C10.1035 5.43635 9.1613 4.49414 7.99902 4.49414C6.83674 4.49414 5.89453 5.43635 5.89453 6.59863C5.89453 7.76091 6.83674 8.70312 7.99902 8.70312Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99244 10.5378C6.40736 8.8066 9.46691 8.71038 12.0072 10.5381C12.2707 10.7277 12.4127 11.0299 12.4127 11.337V12.4305C12.4127 12.7619 12.144 13.0305 11.8127 13.0305H4.18594C3.85457 13.0305 3.58594 12.7619 3.58594 12.4305V11.3373C3.58594 11.03 3.728 10.7274 3.99244 10.5378ZM4.58594 11.3428V12.0305H11.4127V11.3423C9.23914 9.7847 6.65947 9.86247 4.58594 11.3428Z",
    fill: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedUser);
export default __webpack_public_path__ + "static/media/connected_user.7dd9a2a93f55e920d3695e1507284473.svg";
export { ForwardRef as ReactComponent };